<template>
  <div class="floating-labels p-t-10 align-items-start">
    <div class="form-group focused">
      <label class="control-label">Except</label>
      <textarea v-model="except" class="form-control" />
    </div>
    <div class="form-group focused">
      <label class="control-label">Search</label>
      <input v-model="search" class="form-control" />
    </div>
  </div>
  <div
    class="mainHotel label label-danger"
    :key="selectMain.Id"
    v-if="selectMain != null"
  >
    <div>{{ selectMain.Name }}</div>
    <div>{{ selectMain.Region }}</div>
    <div>{{ selectMain.Star }}</div>
  </div>
  <dataTable
    :name="'TourScopeOperatorHotelsHotel'"
    ref="agGrid"
    :columnDefs="columnDefs"
    :data="getData"
    :rowGroupPanelShow="false"
    @update="matchShow = $event"
    @cellClicked="select = $event?.data"
    :rowClassRules="{
      // row style function
      success: (params) => {
        // var numSickDays = params.data;
        return params?.data?.HotelId != null;
      },
      rowClass: (params, select) => {
        // var numSickDays = params.data;
        return params?.data?.Id == select || select == undefined;
      },
    }"
    :doesExternalFilterPass="filter"
  ></dataTable>
</template>

<script>
export default {
  name: "hotels",
  props: ["selectMain", "countryId"],
  data() {
    return {
      columnDefs: [
        {
          headerName: "Id",
          width: 80,
          field: "Id",
          filter: false,
          sortable: true,
          cellClick: true,
          enableRowGroup: false,
        },
        {
          headerName: "Name",
          field: "Name",
          filter: false,
          flex: 2,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: false,
        },
        {
          headerName: "Town",
          field: "DestinationTownName",
          filter: false,
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: false,
        },
        {
          headerName: "Star",
          field: "Star",
          filter: false,
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: false,
        },
      ],
      data: null,
      search: "",
      except:
        "club,resort,hotels,hotel,aqua,grand,the,best,garden,green,holiday,beach",
      select: null,
      matchShow: null,
    };
  },
  watch: {
    select() {
      if (this.select != undefined && this.select != null) {
        this.$refs.agGrid.selectRow([this.select.Id]);
      }
      if (this.select?.Id != undefined) {
        this.$emit("selectHotel", this.select);
      }
    },
    selectMain() {
      this.select = null;
      if (this.selectMain != null) {
        var search = this.selectMain.Name.toLowerCase();
        this.except
          .toLowerCase()
          .split(",")
          .forEach((element) => {
            search = search.replace(element, "");
          });
        this.search = search.trim().split(" ")[0];
      }
    },
    countryId() {
      this.get();
    },
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.data = null;
      this.$appAxiosAdmin
        .get(`Tourscope/OperatorHotels/Hotels/` + this.countryId)
        .then((response) => {
          this.data = response.data;
        });
    },
    filter(params) {
      console.log(params);
    },
  },
  computed: {
    getData() {
      if (this.data == null) {
        return null;
      }
      return this.data.filter((x) => {
        return x.Name.toUpperCase().indexOf(this.search.toUpperCase()) > -1;
      });
    },
  },
};
</script>

<style scoped>
.floating-labels {
  padding-bottom: 10px;
}
.mainHotel {
  margin-bottom: 10px;
  display: table;
  width: 100%;
  border-radius: 0;
}
.mainHotel > div {
  padding: 5px;
  display: table-cell;
}
</style>
